(function ($, Drupal, once) {

  Drupal.behaviors.pagulasabiGoBackButtonJS = {
    attach: function (context, settings) {
      once('pagulasabiGoBackButtonJS', '#go-back-button', context).forEach(function () {
        console.log("Go Back Button.")
        $(this).on('click', function (e) {
          console.log("Go Back!")
          window.history.back()
        });
      });
    }
  }

})(jQuery, Drupal, once);
